module.exports = __webpack_public_path__ + "static/media/industrialIcon.0d390004.svg";